import { merge } from 'lodash';
import { css, createTheme } from '@goodrx/matisse';

export const ColorTranslations = {
  success: 'secondary',
  danger: 'red',
  info: 'primary',
  grey: 'greyLightest',
};

export const getColorFromVariant = ({ theme, variant }: any) =>
  theme.colors[variant] || theme.colors[ColorTranslations[variant]];

export default function themeCreate(overrides: any) {
  const { colors } = createTheme(overrides);

  return merge(
    {
      colors,

      gridWidth: 1184,

      variants: {
        Button: {
          blackText: {
            backgroundColor: 'transparent',
            borderColor: 'transparent',
            color: colors.black,
            outline: 'none',
            '&:hover': {
              color: colors.greyDarkest,
            },
          },
          greyText: {
            backgroundColor: 'transparent',
            borderColor: 'transparent',
            color: colors.greyDarker,
            outline: 'none',
            '&:hover': {
              color: colors.greyDarkest,
            },
          },
        },

        Section: {
          primary: {
            backgroundColor: colors.primary,
            color: 'white',
          },
        },
      },
      styles: {
        Legend: {
          fontSize: 18,
          marginBottom: 12,
          color: colors.black,
        },
        Label: {
          fontWeight: 500,
        },
        FormError: {
          fontSize: 14,
        },
        Select: {
          fontFamily: 'inherit',
          fontWeight: 500,
        },
        Input: css`
          font-weight: 500;

          &:-webkit-autofill,
          &:-webkit-autofill:hover,
          &:-webkit-autofill:focus,
          &:-webkit-autofill:active {
            -webkit-box-shadow: 0 0 0 30px white inset !important;
          }
        `,
        ModalHeader: {
          padding: 16,
          paddingBottom: 0,
        },
        ModalHeaderInner: {
          paddingBottom: 8,
        },
        ModalTitle: {
          fontSize: 18,
        },
        ModalBody: {
          padding: 16,
        },
        ModalFooter: css`
          padding: 0 16px 16px;

          .re-button {
            width: 100%;
          }
        `,
        DropdownTitle: {
          margin: '8px 0 4px 8px',
          color: colors.black,
        },
        DropdownItem: {
          fontSize: 16,
        },
      },

      textStyles: {
        1: {
          sm: {
            fontFamily: 'Tiempos',
            fontSize: '1.75rem',
            fontWeight: '600',
            lineHeight: '2.125rem',
            margin: '0 0 1rem 0',
          },
          md: {
            fontFamily: 'Tiempos',
            fontSize: '2.75rem',
            fontWeight: '600',
            lineHeight: '3rem',
            margin: '0 0 1rem 0',
          },
        },
        2: {
          sm: {
            fontFamily: 'Tiempos',
            fontSize: '1.5rem',
            fontWeight: '600',
            lineHeight: '1.75rem',
            margin: '0 0 1rem 0',
          },
          md: {
            fontFamily: 'Tiempos',
            fontSize: '2.25rem',
            fontWeight: '600',
            lineHeight: '2.625rem',
            margin: '0 0 1rem 0',
          },
        },
        3: {
          sm: {
            fontFamily: 'Avenir',
            fontSize: '1.125rem',
            fontWeight: '500',
            lineHeight: '1.5rem',
            margin: '0 0 1rem 0',
          },
          md: {
            fontFamily: 'Avenir',
            fontSize: '1.25rem',
            fontWeight: '500',
            lineHeight: '1.5rem',
            margin: '0 0 1rem 0',
          },
        },
        4: {
          sm: {
            fontFamily: 'Avenir',
            fontSize: '1rem',
            fontWeight: '800',
            lineHeight: '1.5rem',
            margin: '0 0 1rem 0',
          },
          md: {
            fontFamily: 'Avenir',
            fontSize: '1.375rem',
            fontWeight: '800',
            lineHeight: '1.75rem',
            margin: '0 0 1rem 0',
          },
        },
        5: {
          sm: {
            fontFamily: 'Avenir',
            fontSize: '1rem',
            fontWeight: '500',
            lineHeight: '1.5rem',
            margin: '0 0 1rem 0',
          },
          md: {
            fontFamily: 'Avenir',
            fontSize: '1rem',
            fontWeight: '500',
            lineHeight: '1.5rem',
            margin: '0 0 1rem 0',
          },
        },
        6: {
          sm: {
            fontFamily: 'Avenir',
            fontSize: '0.875rem',
            fontWeight: '500',
            lineHeight: '1.3125rem',
            margin: '0 0 1rem 0',
          },
          md: {
            fontFamily: 'Avenir',
            fontSize: '0.875rem',
            fontWeight: '500',
            lineHeight: '1.3125rem',
            margin: '0 0 1rem 0',
          },
        },
        7: {
          sm: {
            fontFamily: 'Avenir',
            fontSize: '0.75rem',
            fontWeight: '800',
            lineHeight: '0.875rem',
            margin: '0 0 1rem 0',
          },
          md: {
            fontFamily: 'Avenir',
            fontSize: '0.75rem',
            fontWeight: '800',
            lineHeight: '1.125rem',
            margin: '0 0 1rem 0',
          },
        },
        8: {
          sm: {
            fontFamily: 'Avenir',
            fontSize: '1rem',
            fontWeight: '800',
            lineHeight: '1.5rem',
            margin: '0 0 1rem 0',
          },
          md: {
            fontFamily: 'Avenir',
            fontSize: '1rem',
            fontWeight: '800',
            lineHeight: '1.5rem',
            margin: '0 0 1rem 0',
          },
        },
        9: {
          sm: {
            fontFamily: 'Avenir',
            fontSize: '1rem',
            fontWeight: '800',
            lineHeight: '1.25rem',
            margin: '0 0 1rem 0',
          },
          md: {
            fontFamily: 'Avenir',
            fontSize: '1rem',
            fontWeight: '800',
            lineHeight: '1.25rem',
            margin: '0 0 1rem 0',
          },
        },
      },
      xSpace: {
        0: '0',
        1: '0.25rem',
        2: '0.5rem',
        3: '0.75rem',
        4: '1rem',
        5: '1.25rem',
        6: '1.5rem',
        8: '2rem',
        10: '2.5rem',
        12: '3rem',
        16: '4rem',
        20: '5rem',
        24: '6rem',
        32: '8rem',
        40: '10rem',
        48: '12rem',
        56: '14rem',
        64: '16rem',
      },
    },
    overrides
  );
}
